import { render, staticRenderFns } from "./powerManage-memberMaintain.vue?vue&type=template&id=65aed174&scoped=true&"
import script from "./powerManage-memberMaintain.vue?vue&type=script&lang=js&"
export * from "./powerManage-memberMaintain.vue?vue&type=script&lang=js&"
import style0 from "./powerManage-memberMaintain.vue?vue&type=style&index=0&id=65aed174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aed174",
  null
  
)

export default component.exports